import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=7fb043af&scoped=true"
import script from "./Accesses.vue?vue&type=script&lang=js"
export * from "./Accesses.vue?vue&type=script&lang=js"
import style0 from "./Accesses.vue?vue&type=style&index=0&id=7fb043af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb043af",
  null
  
)

export default component.exports